import { Column } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import type { FoundUser } from 'app/network/user';
import { ActivityIndicator, FlatList, type ListRenderItem } from 'react-native';

interface MemberSearchResultsProps {
  canSearch: boolean;
  isSearching: boolean;
  noResultsText: string;
  onEndReached: () => void;
  renderItem: ListRenderItem<FoundUser>;
  results: FoundUser[];
}

const keyExtractor = (item: FoundUser) => item.id;

export function MemberSearchResults({
  canSearch,
  isSearching,
  noResultsText,
  onEndReached,
  renderItem,
  results,
}: MemberSearchResultsProps) {
  return (
    <Column flex={1}>
      {canSearch && isSearching ? (
        <Column alignItems="center" paddingVertical="spacing.general.x8">
          <ActivityIndicator />
        </Column>
      ) : canSearch && results.length === 0 && !isSearching ? (
        <Column alignItems="center" paddingHorizontal="spacing.general.x8" paddingVertical="spacing.general.x8">
          <Text color="text.secondary" textAlign="center">
            {noResultsText}
          </Text>
        </Column>
      ) : (
        <FlatList
          data={results}
          keyExtractor={keyExtractor}
          keyboardShouldPersistTaps="handled"
          onEndReached={onEndReached}
          onEndReachedThreshold={0.4}
          renderItem={renderItem}
        />
      )}
    </Column>
  );
}
